<template>
  <div id="liste_factures">
    <b-col cols="12">
      <GenericTable
        id="tab_liste_factures"
        ref="genericTable"
        :actions="actions"
        :colonnes="cols"
        :endpoint-url="endpoint"
        :filterable-col="filterableCol"
        :display-archive-checkbox="false"
        @row-click="openDetails"
        @action-callback="dispatchAction"
        @row-edited="handleRowEdited"
      />
    </b-col>
    <LibraireModal />
    <ModalExportCommandesFactures />
  </div>
</template>

<script>
import Moment from "moment";
import GenericTable from "@/components/generics/genericTable/GenericTable.vue";
import LibraireModal from "@/components/libraires/LibraireModal.vue";
import ModalExportCommandesFactures from "@/components/commandes/ModalExportCommandesFactures.vue";

import mixinFactures from "@/mixins/mixinFactures";

import Api from "@/modules/axios";
import { displayErrorSelectOne } from "@/modules/utils";

import { spaceNumber } from "@/modules/filters";

export default {
  name: "ListeFactures",
  components: { GenericTable, LibraireModal, ModalExportCommandesFactures },
  mixins: [mixinFactures],
  data() {
    return {
      cols: [
        { key: "numero", defaultOrder: true },
        { key: "libraire" },
        { key: "date" },
        { key: "commande", overrideName: "Commande" },
        { key: "date_echeance" },
        { key: "montant_regle", overrideName: "Montant réglé (€)" },
        { key: "prix_total", overrideName: "Montant dû (€)" },
        {
          key: "date_relance",
          overrideName: "Date relance",
        },
        {
          key: "date_soldee",
          overrideName: "Soldée",
          modifiable: true,
          inputType: "checkbox",
        },
        { key: "infos" },
        { key: "etat", overrideName: "État" },
        { key: "nb_ouvrages", overrideName: "Nombre d'ouvrage(s)" },
      ],
      filterableCol: [
        "numero",
        "libraire__compte",
        "libraire__nom",
        "pays__nom",
        { key: "prix_total", verbose: "Montant dû (€)" },
        { key: "pro_forma__numero", verbose: "pro forma (numéro)" },
        { key: "commande__numero", verbose: "commande (numéro)" },
        { key: "etat", verbose: "État" },
        "",
      ],
      endpoint: "/facture",
    };
  },
  computed: {
    actions() {
      return [{ title: "Exporter", callback: "export" }];
    },
  },
  mounted() {
    this.$store.commit(
      `${this.$route.name}/setFormatDataFunction`,
      this.verboseColFactureForTable,
    );
  },
  methods: {
    openDetails(facture) {
      this.$modal.show("libraire", {
        factureId: facture.id,
        libraire: facture.libraire,
      });
    },
    dispatchAction(actionCode) {
      // On execute le dispatch générique qui gére le delete
      const resCode = this.$refs.genericTable.genericDispatch(
        actionCode,
        this.$route.name,
        this.endpoint,
        "une facture",
      );

      if (resCode === -1) {
        const checkedRows = this.$store.getters[
          `${this.$route.name}/rowDisplayed`
        ].filter((row) => row._checkBoxChecked);

        switch (actionCode) {
          case "export":
            if (checkedRows.length === 1) {
              this.displayModalExport();
            } else {
              displayErrorSelectOne("une facture");
            }
            break;

          default:
            break;
        }
      }
    },
    verboseColFactureForTable(data) {
      const { results } = data;

      results.forEach((ligne) => {
        // Verbose du numéro de commande
        ligne.commande_verbose = ligne.commandes.map((c) => c.numero).join(", ");

        // Verbose du nombre d'ouvrage
        ligne.nb_ouvrages_verbose = spaceNumber(ligne.nb_ouvrages);

        // Verbose du libraire
        ligne.libraire_verbose = ligne.libraire.nom;

        // Verbose de la dernière date de relance
        const tabDates = [
          ligne.date_relance_1,
          ligne.date_relance_2,
          ligne.date_relance_3,
        ];

        tabDates.sort((a, b) => (
          new Moment(b).format("YYYYMMDD") - new Moment(a).format("YYYYMMDD")
        ));
        if (tabDates[0] != null) {
          ligne.date_relance_verbose = new Moment(tabDates[0]).format(
            "DD/MM/YYYY",
          );
        }
      });

      // Verbose de l'user (crée par)
      const usersCreatedIds = [
        ...new Set(results.map((item) => item.user_created)),
      ];

      const promise1 = Api()
        .get(`user/?id__in=${usersCreatedIds.join(",")}&page_size=100`)
        .then((res) => {
          const tabUserCreated = res.data.results;
          results.forEach((ligne) => {
            ligne.user_created_verbose = (
              tabUserCreated.find(
                (userCreated) => ligne.user_created === userCreated.id,
              ) || {}
            ).username;
          });
          return res;
        });

      return promise1;
    },
    displayModalExport() {
      const checkedRows = this.$store.getters[
        `${this.$route.name}/rowDisplayed`
      ].filter((row) => row._checkBoxChecked);

      this.$modal.show("ModalExportCommandesFactures", {
        lignes: checkedRows,
        type: "facture",
      });
    },
  },
};
</script>

<style lang="scss">
#tab_liste_factures {
  padding: 0;

  .numero { width: 120px; }

  .libraire { min-width: 200px; }

  // Centrer les checkboxes
  td:nth-child(11) { text-align: center; }

  .date_relance_1,
  .date_soldee,
  .date,
  .date_echeance { width: 90px; }

  .commande { width: 100px; }

  .infos { min-width: 200px; }

  .etat { width: 150px; }

  .montant_regle,
  .montant_du,
  .nb_ouvrages { width: 90px; }
}
</style>
